const fbLinkSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="22.456px" height="22.456px" viewBox="0 0 22.456 22.456" enable-background="new 0 0 22.456 22.456" xml:space="preserve">
<g id="Layer_1">
	<g>
		<g>
			<path fill="#FFFFFF" d="M19.825,0H2.631C1.181,0,0,1.18,0,2.632v17.192c0,1.451,1.181,2.632,2.631,2.632h17.193
				c1.451,0,2.631-1.181,2.631-2.632V2.632C22.456,1.18,21.276,0,19.825,0z M20.702,19.824c0,0.484-0.394,0.877-0.877,0.877h-5
				v-7.148h2.71l0.448-2.72h-3.158V8.947c0-0.744,0.571-1.316,1.315-1.316h1.799V4.912H16.14c-2.233,0-4.034,1.81-4.034,4.043v1.878
				H9.474v2.72h2.633v7.148H2.631c-0.484,0-0.877-0.393-0.877-0.877V2.632c0-0.483,0.394-0.878,0.877-0.878h17.193
				c0.483,0,0.877,0.395,0.877,0.878V19.824z"/>
		</g>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids" display="none">
</g>
</svg>
`;

export default fbLinkSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/fbLinkSVG.js